import useCreate from "./hooks/useCreate";
import schemaJson from "./schema/SchemaJson.json";
import UISchemaJson from "./schema/UISchema.json";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { CreateOrUpdateGql } from "./queries/createOrUpdate";

function Create() {
  return (
    <GenericMethods.Create<SchemaData, CreateOrUpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      useCreate={useCreate}
      template={{
        schemaJson: schemaJson,
        UISchema: UISchemaJson,
      }}
    />
  );
}

export default Create;
